import React from 'react';
import ReactDOM from 'react-dom/client';
import {BrowserRouter, Routes, Route} from 'react-router-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {ReactKeycloakProvider} from "@react-keycloak/web";
import my_keycloak from "./Keycloak";

const root = ReactDOM.createRoot(document.getElementById('root'));

// Enhanced Keycloak initialization options
const keycloakInitOptions = {
    onLoad: 'login-required',
    checkLoginIframe: false, // Disable iframe to avoid third-party cookie issues
    silentCheckSsoRedirectUri: window.location.origin + '/silent-check-sso.html',
    pkceMethod: 'S256', // Use PKCE for better security
    flow: 'standard', // Use standard flow instead of implicit
};

// Handle Keycloak events
const handleKeycloakEvent = (event, error) => {
    console.log('Keycloak event:', event, error);
    
    if (event === 'onAuthError') {
        console.error('Keycloak authentication error:', error);
    }
    
    if (event === 'onTokenExpired') {
        console.log('Token expired, attempting to refresh...');
    }
};

root.render(
    // Wrapping the application with ReactKeycloakProvider
    <ReactKeycloakProvider 
        authClient={my_keycloak} 
        initOptions={keycloakInitOptions}
        onEvent={handleKeycloakEvent}
    >
        <React.StrictMode>
            <BrowserRouter basename={''}>
                <Routes>
                    <Route path={'/*'} element={<App/>}/>
                </Routes>
            </BrowserRouter>
        </React.StrictMode>
    </ReactKeycloakProvider>
);

reportWebVitals();
